/* KISMET v3.8 — barra "Arma tu 3X1" en colecciones */
(function () {
  var bar = document.querySelector('[data-kb3]');
  if (!bar) return;
  document.body.classList.add('has-kb3');

  var need = parseInt(bar.dataset.qty, 10) || 3;
  var slots = bar.querySelectorAll('.kb3__slot');
  var countEl = bar.querySelector('[data-kb3-count]');
  var titleEl = bar.querySelector('[data-kb3-title]');
  var nEl = bar.querySelector('[data-kb3-n]');
  var baseTitle = bar.dataset.title || (titleEl && titleEl.textContent) || '';
  /* Etiqueta "1 de 2" junto al título */
  var pkEl = null;
  if (countEl) { pkEl = document.createElement('span'); pkEl.className = 'kb3__pk'; pkEl.hidden = true; }
  var protId = (window.KISMET && window.KISMET.protection && window.KISMET.protection.variantId) || null;
  var lastN = -1;

  /* En la colección, el "+" agrega sin abrir el carrito: la barra se llena */
  var C = window.KISMET && window.KISMET.cart;
  if (C && C.add && !C.__kb3) {
    var origAdd = C.add;
    C.add = function (items, opts) {
      opts = opts || {};
      if (opts.open === undefined) opts.open = false;
      return origAdd.call(C, items, opts);
    };
    C.__kb3 = true;
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function paint(items, settle) {
    var pics = [];
    items.forEach(function (it) {
      if (protId && it.variant_id === protId) return;
      /* Playeras y sudaderas cuentan para el 3X1 */
      if (it.product_type && it.product_type !== 'Playera' && it.product_type !== 'Sudadera') return;
      for (var q = 0; q < it.quantity; q++) pics.push({ img: it.image, title: it.product_title });
    });
    var n = pics.length;
    var rem = n % need;
    var complete = n > 0 && rem === 0;
    /* Al completar un paquete se festeja un momento con las 3 fotos y luego
       los espacios quedan vacíos para armar el siguiente (6X2, 9X3…) */
    var justDone = complete && !settle && lastN !== -1 && lastN < n;
    var shown = complete ? (justDone ? need : 0) : rem;
    var start = n - shown;

    slots.forEach(function (slot, i) {
      var p = i < shown ? pics[start + i] : null;
      var had = slot.classList.contains('is-on');
      var img = slot.querySelector('img');
      if (p) {
        if (!img) { img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; slot.appendChild(img); }
        var src = thumb(p.img);
        if (img.getAttribute('src') !== src) img.setAttribute('src', src);
        img.alt = p.title || '';
        slot.classList.add('is-on');
        if (!had && lastN !== -1) { slot.classList.remove('is-pop'); void slot.offsetWidth; slot.classList.add('is-pop'); }
      } else {
        if (img) img.remove();
        slot.classList.remove('is-on', 'is-pop');
      }
    });

    /* Paquetes: 3X1 → 6X2 → 9X3 … */
    var packs = Math.floor(n / need);
    var left = need - shown;
    var next = packs + 1; /* paquete que se está armando */
    function combo(t) { return (need * t) + 'X' + t; }
    function armaTu(t) {
      var r = baseTitle.replace(/\d+\s*X\s*\d+/i, combo(t));
      return r === baseTitle && t > 1 ? 'Arma tu ' + combo(t) : r;
    }
    var title, txt, pk = '';
    if (n === 0) { title = baseTitle; txt = 'Elige ' + need + ' y paga solo 1'; }
    else if (justDone) { title = armaTu(packs); pk = packs > 1 ? packs + ' de ' + packs : ''; txt = '¡Tu ' + combo(packs) + ' está listo!'; }
    else { title = armaTu(next); if (packs > 0) pk = packs + ' de ' + next; txt = (packs > 0 ? 'Falta' : 'Te falta') + (left > 1 ? 'n ' : ' ') + left + ' para tu ' + combo(next); }
    if (titleEl) titleEl.textContent = title;
    countEl.textContent = '';
    if (pkEl) { pkEl.textContent = pk; pkEl.hidden = !pk; countEl.appendChild(pkEl); }
    countEl.appendChild(document.createTextNode(txt));
    if (nEl) nEl.textContent = n;
    if (justDone) { bar.classList.remove('is-cheer'); void bar.offsetWidth; bar.classList.add('is-cheer'); }
    bar.classList.toggle('is-done', justDone);
    bar.classList.toggle('is-empty', n === 0);
    lastN = n;
    if (justDone) setTimeout(function () { paint(items, true); }, 1800);
  }

  var t = null;
  function refresh() {
    clearTimeout(t);
    t = setTimeout(function () {
      fetch((window.KISMET && window.KISMET.routes && window.KISMET.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { paint(c.items || []); })
        .catch(function () {});
    }, 120);
  }

  refresh();
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        if (list[i].type === 'attributes' && list[i].attributeName === 'data-real-count') { refresh(); return; }
        if (list[i].type === 'childList' && list[i].target === drawer) { refresh(); return; }
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['data-real-count'], childList: true });
    /* esconder la barra mientras el carrito está abierto */
    new MutationObserver(function () {
      bar.classList.toggle('is-hidden', drawer.classList.contains('is-open'));
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
})();

/* Galería de producto: al cambiar de color, volver al inicio para ver sus fotos */
(function () {
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var pick = root.querySelector('[data-variant-picker]');
    var gal = root.querySelector('[data-gallery]');
    if (!pick || !gal) return;
    pick.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || t.getAttribute('data-option') !== root.dataset.colorIndex) return;
      setTimeout(function () {
        gal.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
        var r = gal.getBoundingClientRect();
        if (window.matchMedia('(min-width: 990px)').matches && r.top < 0) window.scrollBy({ top: r.top - 120, behavior: 'smooth' });
      }, 60);
    });
  });
})();

/* Galería de producto (v3.11): contador real por color, cuadritos de vista previa y mockups más chicos */
(function () {
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var gal = root.querySelector('[data-gallery]');
    if (!gal) return;
    var wrap = gal.closest('.pdp__gallery') || gal.parentNode;
    var items = Array.prototype.slice.call(gal.querySelectorAll('.gal__item'));
    var counter = wrap.querySelector('[data-gallery-count]');
    if (items.length < 2) return;

    /* Mockups (espalda / frente): la playera completa dentro del recuadro, como en FATE */
    items.forEach(function (it) {
      var a = it.getAttribute('data-media-alt') || '';
      if (a.indexOf('espalda') > -1 || a.indexOf('frente') > -1) it.classList.add('is-flat');
    });

    /* Cuadritos de vista previa */
    var strip = document.createElement('div');
    strip.className = 'gal__thumbs';
    strip.setAttribute('aria-label', 'Fotos del producto');
    var thumbs = items.map(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gal__thumb' + (it.classList.contains('is-flat') ? ' is-flat' : '');
      b.setAttribute('aria-label', 'Ver foto ' + (i + 1));
      var img = it.querySelector('img');
      if (img) {
        var src = img.currentSrc || img.src || '';
        src = src.replace(/([?&])width=\d+/, '$1width=200');
        if (src.indexOf('width=') < 0) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
        var t = document.createElement('img'); t.src = src; t.alt = ''; t.loading = 'lazy'; b.appendChild(t);
      }
      b.addEventListener('click', function () {
        if (gal.scrollWidth > gal.clientWidth + 4) gal.scrollTo({ left: it.offsetLeft - gal.offsetLeft, behavior: 'smooth' });
        else it.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      strip.appendChild(b);
      return b;
    });
    wrap.parentNode.insertBefore(strip, wrap.nextSibling); /* debajo de la foto, sin tapar el contador */

    function visible() { return items.filter(function (it) { return !it.classList.contains('is-filtered'); }); }
    function current(vis) {
      if (gal.scrollWidth <= gal.clientWidth + 4) return 0;
      var x = gal.scrollLeft, best = 0, d = Infinity;
      vis.forEach(function (it, i) { var dd = Math.abs((it.offsetLeft - gal.offsetLeft) - x); if (dd < d) { d = dd; best = i; } });
      return best;
    }
    var raf = 0;
    function update() {
      raf = 0;
      var vis = visible(), idx = current(vis);
      items.forEach(function (it, i) {
        var on = vis.indexOf(it) > -1;
        thumbs[i].hidden = !on;
        thumbs[i].classList.toggle('is-active', on && vis.indexOf(it) === idx);
      });
      strip.hidden = vis.length < 2;
      if (counter) { counter.textContent = (idx + 1) + ' / ' + vis.length; counter.hidden = vis.length < 2; }
      var act = strip.querySelector('.is-active');
      if (act && strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: act.offsetLeft - strip.clientWidth / 2 + act.clientWidth / 2, behavior: 'smooth' });
    }
    function queue() { if (!raf) raf = requestAnimationFrame(function () { setTimeout(update, 0); }); }
    gal.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    if (window.MutationObserver) new MutationObserver(queue).observe(gal, { subtree: true, attributes: true, attributeFilter: ['class'] });
    update();
    setTimeout(update, 300);
  });
})();

/* Viene de una tarjeta por color (?variant=…&kc=1): se queda el color de la tarjeta,
   pero la talla la elige el cliente (no se preselecciona la S). */
(function () {
  if (!/[?&]kc=1(&|$)/.test(location.search)) return;
  var root = document.querySelector('[data-product]');
  if (!root || root.dataset.requireSize !== 'true') return;
  var si = parseInt(root.dataset.sizeIndex, 10); if (!(si >= 0)) return;
  var picker = root.querySelector('[data-variant-picker]');
  root.querySelectorAll('.vp__opt[data-option-index="' + si + '"] input').forEach(function (i) { i.checked = false; });
  var sab = root.querySelector('[data-sab-size]'); if (sab) sab.value = '';
  if (picker) picker.dispatchEvent(new Event('change', { bubbles: true }));
})();
